// Centraliseret hjælper til at vælge den slug, vi bruger i bil-URLer.
// Whitespace-only `seo_slug` (fx "   ") må ALDRIG bruges som slug — ellers
// ender vi med URLer som "/biler-til-salg/   " der peger på 404. Trim først,
// fald tilbage til `id` hvis den effektive slug er tom.

export function resolveCarSlug(car: { seo_slug?: string | null; id: string }): string {
  const trimmed = car.seo_slug?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : car.id;
}
